"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 38: PCI556 (UNL-PCI556)
 * ------------------------------------------------------------------ *
 * A GxROM (mapper 66) clone whose register sits at the top of the work
 * RAM window instead of in the cartridge space:
 *   bits 0-1: 32 KB PRG bank at $8000-$FFFF
 *   bits 2-3: 8 KB CHR bank at $0000-$1FFF
 * Used by Bit Corp's Crime Busters.
 * See https://www.nesdev.org/wiki/INES_Mapper_038
 */

function register(Mappers) {
  Mappers[38] = function (nes) {
    this.nes = nes;
  };

  Mappers[38].prototype = new Mappers[0]();

  Mappers[38].prototype.write = function (address, value) {
    if (address < 0x7000 || address > 0x7fff) {
      // Outside the register the board answers as NROM -- except in the PRG
      // range, where there is nothing to write and NROM's handler would copy
      // the value over the ROM windows in cpu.mem.
      if (address < 0x8000) {
        Mappers[0].prototype.write.apply(this, arguments);
      }
      return;
    }

    // ..CC PP: the same two fields GxROM decodes, only at a lower address.
    this.load32kRomBank(value & 0x03, 0x8000);
    this.load8kVromBank(((value >> 2) & 0x03) * 2, 0x0000);
  };
}

module.exports = { register: register };
